























































































import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import RepairEstimatePartyForm from "@/components/repair-estimate/RepairEstimatePartyForm.vue";
import RefsClearanceApproval from "@/components/utility/RefsClearanceApproval.vue";
import RefsSelect from "@/components/utility/RefsSelect.vue";
import SelectEntity from "@/components/utility/SelectEntity.vue";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import { IClearance } from "@/models/clearance.entity";
import { Reference } from "@/models/reference.entity";
import { IRepairEstimate } from "@/models/repair-estimate.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent, SharedContent } from "@/models/shared-content.entity";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import InvoicePartyForm from "../invoice/InvoicePartyForm.vue";
import LineItemsForm from "../repair-estimate/LineItemsForm.vue";

export enum ClearanceApprovalSteps {
  SELLER = "seller",
  EXPIRATION = "expiration",
  LINE_ITEMS = "lineItems",
  SEND_MAIL = "sendMail",
  SUCCESS = "success"
}

@Component({
  components: {
    RepairEstimatePartyForm,
    PreselectTemplateCard,
    RefsClearanceApproval,
    RefsSelect,
    LineItemsForm,
    SelectEntity
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ClearanceApprovalCreateStepper extends mixins(PermissionMixin, RulesMixin) {
  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly ClearanceApprovalSteps = ClearanceApprovalSteps;

  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;

  readonly CurrencyEnum = CurrencyEnum;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  @Prop()
  value!: IClearanceApproval;

  @Prop()
  step!: ClearanceApprovalSteps;

  @Prop({ default: false })
  hideRefsSelect!: boolean;

  @Prop({ default: false })
  refsSelectAsList!: boolean;

  @Prop()
  sellerCompanyId?: string;

  @Prop()
  report!: IReport;

  @Prop()
  repairEstimate!: IRepairEstimate;

  @Prop({ required: true })
  clearance!: IClearance;

  sharedContent: ISharedContent = new SharedContent({ partnerId: this.value.partnerId });

  requestsLoading = false;

  created: IClearanceApproval[] = [];

  get attachmentFileFilters() {
    return this.value.report?.refFilter || [];
  }

  get categories(): BackendResourceEnum[] {
    return this.value.refsCategories;
  }

  get stepLocal() {
    return this.step;
  }

  set stepLocal(step: ClearanceApprovalSteps) {
    this.$emit("update:step", step);
  }

  get templateRefs() {
    return [...this.value.refs, { refId: this.value.id, refType: ResourceEnum.CLEARANCE_APPROVAL }];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get context() {
    return {
      clearanceApproval: this.value,
      sharedContent: this.sharedContent,
      partner: this.partner,
      vehicle: this.value.report?.vehicle,
      report: this.value.report,
      clearance: this.clearance,
      url: { sharing: this.sharedContent.url }
    };
  }

  mounted() {
    this.setSellerFromCompanyId();
    this.onReportIdChange();
  }

  @Watch("value.reportId")
  async onReportIdChange() {
    await this.value.fetchReportAndVehicle().catch(this.$log.error);
  }

  @Watch("sellerCompanyId")
  setSellerFromCompanyId() {
    if (this.sellerCompanyId) {
      (this.$refs.sellerForm as InvoicePartyForm)?.setInvoicePartyFromCompanyOrPersonRef([
        {
          refId: this.sellerCompanyId,
          refType: ResourceEnum.COMPANY
        }
      ]);
    }
  }

  async createRequests() {
    this.requestsLoading = true;
    try {
      if (this.report?.id) {
        this.value.reportId = this.report.id;
      }
      if (!this.value.id) {
        await this.value.create();
        this.$emit("created", this.value);
        if (this.clearance) {
          this.clearance.updatePartial({
            clearanceApprovalIds: [...(this.clearance.clearanceApprovalIds || []), this.value.id]
          });
        }
      }

      this.sharedContent.refs = [...this.value.refs];
      if (this.value.id) {
        this.sharedContent.refs.push(new Reference({ refId: this.value.id, refType: ResourceEnum.CLEARANCE_APPROVAL }));
      } else {
        throw new Error("Clearance approval request ID is not defined");
      }

      await this.sharedContent.create();

      this.created.push(this.value);
      this.$emit("create:sharedContent", this.sharedContent);
      this.stepLocal = ClearanceApprovalSteps.SEND_MAIL;
    } catch (e) {
      handleError(e);
    }
    this.requestsLoading = false;
  }
}
